import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton';
import './SkeletonScreenFAQs.scss'
const SkeletonScreenFAQs = () => {
  return (
    <div className='articles-skeleton'>
        <div className="articles-skeleton--header">
            <Skeleton variant='rect' animation="wave" width={327} height={36}/>
            <Skeleton variant='rect' animation="wave" width={295} height={36}/>
        </div>
        <div className="articles-skeleton--contents">
            {
                [1,2].map((i)=>{
                    return (
                        <div className='articles-skeleton--contents-para'>
                        <Skeleton variant='rect' animation="wave" width={327} height={24}/>
                        <Skeleton variant='rect' animation="wave" width={299} height={24}/>
                        <Skeleton variant='rect' animation="wave" width={317} height={24}/>
                        <Skeleton variant='rect' animation="wave" width={226} height={24}/>
                         </div>
                    )
                })
            }
        </div>

        <div className="articles-skeleton--user-response">
            <Skeleton variant='rect' animation="wave" width={277} height={27}/>
        </div>
        <div className="articles-skeleton--user-response-buttons">
            <Skeleton variant='rect' animation="wave" width={123} height={24}/>
            <Skeleton variant='rect' animation="wave" width={124} height={24}/>
        </div>
        
    </div>
  )
}

export default  SkeletonScreenFAQs;